<template>
  <div class="warnRanking" ref="warnRanking">
    <div class="warnRankingBg"></div>

    <ul>
      <li>
        <div class="li_name">{{ dataList[0] ? dataList[0].alarmName : "" }}</div>

        <div class="li_length">
          <div class="block block0" :style="{ width: '90%' }"></div>
        </div>

        <div class="li_count number">{{ dataList[0] ? dataList[0].totalCount : "" }}</div>
      </li>

      <li>
        <div class="li_name">{{ dataList[1] ? dataList[1].alarmName : "" }}</div>

        <div class="li_length">
          <div class="block block1" :style="{
              width: widthCom(dataList[1], dataList[0]),
            }"></div>
        </div>

        <div class="li_count number">{{ dataList[1] ? dataList[1].totalCount : "" }}</div>
      </li>

      <li>
        <div class="li_name">{{ dataList[2] ? dataList[2].alarmName : "" }}</div>

        <div class="li_length">
          <div class="block block2" :style="{
              width: widthCom(dataList[2], dataList[0]),
            }"></div>
        </div>

        <div class="li_count number">{{ dataList[2] ? dataList[2].totalCount : "" }}</div>
      </li>
    </ul>
  </div>
</template>



<script>
export default {
  props: ['matrix', 'x', 'y'],

  data() {
    return {
      pageInfo: 'warnRanking.vue',
      computedName: '告警类型排放组件',
      customerId: this.$store.state.customerId,

      dataList: [{}, {}, {}],
      timer: null,
      styleType: ''
    }
  },

  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType
    },

    widthCom() {
      return function (num1, num2) {
        if (num1 && num2 && num1.totalCount && num2.totalCount) {
          return (num1.totalCount / num2.totalCount) * 0.9 * 100 + '%'
        } else {
          return '0%'
        }
      }
    }
  },

  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal

        this.typeChange()
      },

      deep: true
    }
  },

  created() {
    this.styleType = this.$store.state.styleType
  },

  mounted() {
    let that = this

    let w = $(that.$refs.warnRanking).outerWidth()

    let h = $(that.$refs.warnRanking).outerHeight()

    that.$emit('componentInit', {
      w: w,

      h: h,

      matrixType: that.matrix,

      x: that.x,

      y: that.y
    })

    this.getListData()

    this.typeChange()
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
  methods: {
    typeChange() {
      if (this.styleType == 'typeGreen') {
        this.$nextTick(() => {
          $('.warnRanking .block0').addClass('block4')

          $('.warnRanking .block1').addClass('block5')

          $('.warnRanking .block2').addClass('block6')

          $('.warnRanking>ul').addClass('ul_green')
        })
      } else if (this.styleType == 'typeDark') {
        this.$nextTick(() => {
          $('.warnRanking .block0').removeClass('block4')

          $('.warnRanking .block1').removeClass('block5')

          $('.warnRanking .block2').removeClass('block6')

          $('.warnRanking>ul').removeClass('ul_green')
        })
      }
    },

    async getListData() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      let getTopAlarmInfos = CONFIG.requestName + this.$apiOpt.getTopAlarmInfos

      let res = await this.$apiUtils.get(getTopAlarmInfos, {
        customerId: this.customerId
      })

      if (res && res.length) {
        if (this.customerId === 46) {
          this.dataList = res.filter(item => item.alarmName.indexOf('离线') == -1)
        } else {
          this.dataList = res
        }
      }
      this.timer = setTimeout(() => {
        this.getListData()
      }, 5 * 60 * 1000)
    }
  }
}
</script>



<style lang="scss" scoped="scoped">
.warnRanking {
  height: 250px;

  width: 600px;

  .warnRankingBg {
    @include bg-box(560px, 178px, 'warnRankingBg.png');

    margin-top: 32px;

    position: absolute;
  }

  ul {
    margin-top: 56px;

    height: 126px;

    li {
      height: 42px;

      display: flex;

      line-height: 44px;

      .li_name {
        z-index: 2;

        width: 31%;

        padding-left: 9%;

        white-space: nowrap;

        overflow: hidden;

        text-overflow: ellipsis;

        font-size: 15px;

        font-weight: 400;

        color: #e4fcff;
      }

      .li_length {
        z-index: 2;

        width: 50%;

        padding-left: 6px;

        .block {
          margin-top: 8px;

          border-radius: 0px 2px 2px 0px;

          height: 30px;
        }
      }

      .li_count {
        z-index: 2;

        width: 19%;

        font-size: 22px;

        font-weight: 400;

        color: #d5efff;

        padding-right: 4%;

        text-align: end;
      }
    }

    li:nth-child(2) {
      .li_count {
        color: #b7ffc7;
      }
    }

    li:nth-child(3) {
      .li_count {
        color: #f4d4a0;
      }
    }
  }
}

ul.ul_green {
  li {
    .li_count {
      color: #05fffa !important;
    }
  }

  li:nth-child(2) {
    .li_count {
      color: #0091ff !important;
    }
  }

  li:nth-child(3) {
    .li_count {
      color: #f7b500 !important;
    }
  }
}
</style>

<style scoped>
.block0 {
  background: linear-gradient(270deg, #d7f1ff 0%, #79a9ff 100%);
}

.block1 {
  background: linear-gradient(270deg, #dcffe5 0%, #b6ffc6 100%);
}

.block2 {
  background: linear-gradient(270deg, #faebcb 0%, #f4d29c 100%);
}

.block4 {
  background: linear-gradient(90deg, rgba(5, 251, 246, 0) 0%, #05fffa 100%) !important;
}

.block5 {
  background: linear-gradient(90deg, rgba(0, 145, 255, 0) 0%, #0091ff 100%) !important;
}

.block6 {
  background: linear-gradient(90deg, rgba(247, 181, 0, 0) 0%, #f7b500 100%) !important;
}
</style>

